import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const DistanceSelector = ({ currentRange, onRangeChange }) => {
	const labels = useLabels();
	const distanceText = labels.get('DISTANCE');

	const mileRanges = [10, 25, 50, 100, 200, 500];

	const handleRangeChange = (event) => {
		const newRange = parseInt(event.target.value, 10);

		if (onRangeChange) {
			onRangeChange(newRange);
		}
	};

	return (
		<div className="no-results-distance-container my-4">
			<label
				htmlFor="distance-select"
				className="form-label font-weight-bold mb-2 d-block text-left text-muted"
			>
				{distanceText}
			</label>
			<select
				id="distance-select"
				className="form-control"
				value={currentRange}
				onChange={handleRangeChange}
				aria-label={`${distanceText} selector, currently ${currentRange} miles`}
			>
				{mileRanges.map((range) => (
					<option key={range} value={range}>
						{range} miles
					</option>
				))}
			</select>
		</div>
	);
};

DistanceSelector.propTypes = {
	currentRange: PropTypes.number,
	onRangeChange: PropTypes.func
};

export default DistanceSelector;
